/**
 * Provide Cars brand tokens — Royal Navy + Gold palette.
 *
 * Mirrors `new_wp/frontend` Tailwind brand-* tokens so the customer-portal
 * SPA reads as a sibling of the marketing site. customer-portal does not
 * depend on Tailwind, so these are exported as plain JS constants and
 * consumed via inline styles (same pattern as AppShell.tsx).
 *
 * Color reference: provided by SSOT design feedback 2026-05-14.
 */
export const BRAND = {
  navy950: '#000028',
  navy900: '#00003A',
  navy800: '#10103C',
  navy700: '#1A1A5E',
  navy600: '#262670',
  navy500: '#3A3A86',
  /** Gold accent — CTA backgrounds. */
  gold500: '#C9A94E',
  gold400: '#D6BC68',
  gold600: '#A88B33',
  beige100: '#FBF7EE',
  beige200: '#F2E8D2',
  beige300: '#E5D9C0',
  beige400: '#C9B894',
  white: '#FFFFFF',
  /** Slate borders / dividers on light surfaces. */
  slate200: '#E2E8F0',
  slate300: '#CBD5E1',
  slate500: '#64748B',
  slate700: '#334155',
  /** Text-on-navy variants. */
  onNavyMuted: 'rgba(255, 255, 255, 0.7)',
  onNavyStrong: '#FFFFFF',
  onNavyDivider: 'rgba(255, 255, 255, 0.08)',
} as const;

export const MAX_CONTENT_WIDTH = 1760;

/**
 * Standard horizontal padding token (matches `px-4 sm:px-6 xl:px-12 2xl:px-16`).
 * Implemented as CSS clamp() so it scales with viewport without media queries.
 */
export const CONTAINER_PADDING_X = 'clamp(1rem, 4vw, 4rem)';

/** Common shadow used by sticky chrome surfaces. */
export const SHADOW_HEADER = '0 1px 3px 0 rgba(0, 0, 0, 0.05)';
